$           = require('jquery');
var angular = require('angular');
var _       = require('lodash');
var _module = angular.module('listreports.main-menu', []);

require('angular-animate');
require('ng-dialog');
require('slick-carousel');
require('angular-slick');
require('../../libs/angular-youtube-mb');
require('../core/mark-active');
require('../core/slick-gallery-item-clicked');
require('../core/utils');
require('../core/filters');
require('../core/fill-height');
require('../cached-templates/templates');
require('../modals/modal-pane');
require('../modals/about-listreports');
require('../modals/people-love-us');
require('../modals/product-benefits');
require('../modals/marketing-materials');
require('../modals/numbers-dont-lie');
require('../modals/meet-your-rep');
require('../slick-sync');
require('../events');
require('../sdr');
require('angular-sanitize');
require('../../libs/pendo');
require('angular-google-maps');


_module.requires.push(
    'ngAnimate',
    'ngSanitize',
    'ngDialog',
    'angular-slick',
    'listreports.core',
    'templates',
    'listreports.modals',
    'angular-slick.sync',
    'listreports.events',
    'pendolytics',
    'listreports.sdr'
);
_module.filter('unique', function() {
    return function (collection, field) {
        return _.uniq(collection, field);
    };
});

_module.controller('MainMenuController', [
    '$log',
    '$scope',
    '$rootScope',
    '$compile',
    '$utils',
    'ngDialog',
    '$events',
    '$location',
    '$window',
    '$pendolytics',
    '$stateParams',
    '$sdr',
    '$state',
    function($log, $scope, $rootScope, $compile, $utils, ngDialog, $events, $location, $window, $pendolytics, $stateParams, $sdr, $state) {
        var that = this;

        this.sdr       = {};

        $scope.sdrView = {};

        $scope.pageMoving = false;

        $scope.nestUrl = "https://nest.me";
        $scope.demo = ($location.search().demo || '').toLowerCase() === 'true' ? true : false;

        $scope.showAboutListreports   = false;
        $scope.showPeopleLoveUs       = false;
        $scope.showProductBenefits    = false;
        $scope.showMarketingMaterials = false;
        $scope.showNumbersDontLie     = false;
        $scope.showMeetYourRep        = false;


        // $scope Functions

        $scope.isAnyCardShowing = function(){
            return $scope.showAboutTheHome || $scope.showEnhancedGallery
            || $scope.showExploreTheArea || $scope.showGetFinanced
            || $scope.showGuideByName || $scope.showMeetYourLender
            || $scope.showMeetYourRealtor || $scope.showOpenHouseInfo || $scope.showRealtorContactUs;
        };

        $scope.openAboutListreports = function() {
            if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                $scope.showAboutListreports = true;
                $events.track('Box Click', {
                    'Source': 'About ListReports',
                    'SDR Name': that.sdr.name
                });
            }
        };

        $scope.openPeopleLoveUs = function() {
            if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                $scope.showPeopleLoveUs = true;
                $events.track('Box Click', {
                    'Source': 'Why people love us',
                    'SDR Name': that.sdr.name
                });
            }
        };

        $scope.openProductBenefits = function() {
            if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                $scope.showProductBenefits = true;
                $events.track('Box Click', {
                    'Source': 'Product benefits',
                    'SDR Name': that.sdr.name
                });
            }
        };

        $scope.openMarketingMaterials = function() {
            if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                $scope.showMarketingMaterials = true;
                $events.track('Box Click', {
                    'Source': 'Marketing materials',
                    'SDR Name': that.sdr.name
                });
            }
        };

        $scope.openNumbersDontLie = function() {
            if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                $scope.showNumbersDontLie = true;
                $events.track('Box Click', {
                    'Source': "Our numbers don't lie",
                    'SDR Name': that.sdr.name
                });
            }
        };

        $scope.openMeetYourRep = function() {
            if(!$scope.pageMoving && !$scope.isAnyCardShowing()){
                $scope.showMeetYourRep = true;
                $events.track('Box Click', {
                    'Source': 'Meet your account rep',
                    'SDR Name': that.sdr.name
                });
            }
        };

        $scope.trackCLickEvent = function trackCLickEvent(eventName, eventData) {
            if(!$scope.pageMoving){
                $events.track(eventName, eventData);
            }
        };

        $scope.displayAsLocalTime = function (dateString) {
            var t = dateString;
            if(dateString) {
                t = new Date(dateString);
                t = new Date( t.getTime() + ( t.getTimezoneOffset() * 60000 ) );
            }

            return t;
        };

        $scope.redirect = function(url) {
            window.location.href = url;
        };

        $scope.scheduleCall = function() {
            $events.track('Schedule A Call Click', {
                'SDR Name': that.sdr.name
            });
            $window.open(that.sdr.website, '_blank');
        };

        $scope.signUp = function() {
            $events.track('Sign Up Click', {
                'SDR Name': that.sdr.name
            });
            var lrSiteUrl  = "https://pro.listreports.com";
            var url = lrSiteUrl + '/sign-up';
            if(that.sdr.refCodeId)
                url = url + '?ref=' + that.sdr.refCodeId;
            $window.open(url, '_blank');
        };

        $window.ontouchmove = function(e){
            $scope.pageMoving = true;
        };

        $window.ontouchend = function(e){
            $scope.pageMoving = false;
        };

        // Trigger Pendo if demo true
        try {
            $pendolytics.identify({
                visitor: {
                    id: 'VISITOR-UNIQUE-ID',   // Required if user is logged in
                    demo: $scope.demo
                },

                account: {}
            });

            if($scope.demo) {
                setTimeout(function () {
                    pendo.showGuideByName('Prop Website - Offer Banner');
                }, 1000);
            }
        } catch (err) {
            $log.error('Pendo Error', err);
        }

        this.init = function() {
            $sdr.fetchSdrInfo($stateParams.userId).then(function(response) {
                that.sdr = response;
                $scope.sdrView = $sdr.parseSrdFields(response);
                $events.track('Page View', {
                    'SDR Name': that.sdr.name
                });
            })
            .catch(function(err) {
                $state.go('four0four');
            });
        };

        this.init();

    }
]);


module.exports = _module;
